/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('ext.head-search', function (el) {
        var headSearch = new HeadSearch();
        headSearch.run();
    });
    var HeadSearch = /** @class */ (function () {
        function HeadSearch() {
            this.body = document.body;
            this.searchToggle = document.getElementById('searchToggle');
            this.searchDrop = document.getElementById('searchDrop');
            this.searchClose = document.getElementById('searchClose');
            this.header = document.querySelector('header');
        }
        HeadSearch.prototype.run = function () {
            this.bind();
            this.appendToHeader();
        };
        HeadSearch.prototype.bind = function () {
            var _this = this;
            util.delegate(this.searchToggle, 'click', '#' + this.searchToggle.id, function (e) {
                if (_this.body.classList.contains('search-open')) {
                    _this.closeSearch();
                }
                else {
                    _this.body.classList.add('search-open');
                    var qElm = _this.searchDrop.querySelector('#q');
                    qElm.focus();
                }
            });
            util.delegate(this.searchClose, 'click', '#' + this.searchClose.id, function (e) {
                _this.closeSearch();
            });
            document.addEventListener('keydown', function (e) {
                if (e.code === 'Escape') {
                    _this.closeSearch();
                }
            });
            document.addEventListener('click', function (e) {
                if (_this.body.classList.contains('search-open')) {
                    if (e.target instanceof Node) {
                        if (!_this.searchDrop.contains(e.target) && _this.mobileToggle !== (e.target) && _this.searchToggle !== (e.target)) {
                            _this.closeSearch();
                        }
                    }
                }
            });
            document.addEventListener('touchstart', function (e) {
                if (_this.body.classList.contains('search-open')) {
                    if (e.target instanceof Node) {
                        if (!_this.searchDrop.contains(e.target) && _this.mobileToggle !== (e.target) && _this.searchToggle !== (e.target)) {
                            _this.closeSearch();
                        }
                    }
                }
            });
        };
        HeadSearch.prototype.closeSearch = function () {
            this.body.classList.remove('search-open');
        };
        HeadSearch.prototype.appendToHeader = function () {
            var _this = this;
            // Add search to header
            var clone = this.searchToggle.cloneNode();
            clone.classList.add('mobile-only');
            this.header.querySelector('.contentWrap').prepend(clone);
            this.mobileToggle = clone;
            util.delegate(clone, 'click', '#' + clone.id, function (e) {
                if (_this.body.classList.contains('search-open')) {
                    _this.closeSearch();
                }
                else {
                    _this.body.classList.add('search-open');
                    var qElm = _this.searchDrop.querySelector('#q');
                    qElm.focus();
                }
            });
        };
        return HeadSearch;
    }());

    exports.HeadSearch = HeadSearch;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
